import { adminCompaniesEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";

export const deleteCompanyHandler = async (id: number | string): Promise<void> => await axiosClient["delete"](adminCompaniesEndpoints.byId(id));
